import * as Types from '../../generated.types'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type UpdateOrganizationMutationVariables = Types.Exact<{
  input: Types.UpdateOrganizationInput
}>

export type UpdateOrganizationMutation = {
  __typename?: 'Mutation'
  updateOrganization?: {
    __typename?: 'UpdateOrganizationPayload'
    organization?: {
      __typename?: 'Organization'
      id: number
      ein?: string | null
      tel?: string | null
      websiteUrl?: string | null
      businessStructure?: Types.OrganizationBusinessStructure | null
      address?: {
        __typename?: 'AddressDisplay'
        line1?: string | null
        line2?: string | null
        cityName?: string | null
        stateCode?: string | null
        zipcode?: string | null
        isVerified: boolean
        verificationStatus?: Types.AddressVerificationStatus | null
      } | null
    } | null
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const UpdateOrganizationDocument = `
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    organization {
      id
      ein
      tel
      websiteUrl
      businessStructure
      address {
        line1
        line2
        cityName
        stateCode
        zipcode
        isVerified
        verificationStatus
      }
    }
    inputErrors {
      argument
      message
    }
  }
}
    `
export const useUpdateOrganizationMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateOrganizationMutation,
    TError,
    UpdateOrganizationMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateOrganizationMutation, TError, UpdateOrganizationMutationVariables, TContext>(
    ['UpdateOrganization'],
    (variables?: UpdateOrganizationMutationVariables) =>
      fetchGql<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(
        UpdateOrganizationDocument,
        variables
      )(),
    options
  )
